<div class="row">
  <div class="col-lg-12">
    <div class="container-fluid">
      <ng-container *ngIf="!isFreemium">
        <app-pie-chart [data]="pieChartData" [height]="'600px'"></app-pie-chart>
      </ng-container>
      <app-data-table-component [headers]="headers" [currentSort]="'totalTrafficRatio'" [data]="subdomains" [limit]=5></app-data-table-component>
    </div>
  </div>
</div>

<ng-template #domainTemplate let-item='item'>
  <img class="mr-1" width="16" src="https://www.google.com/s2/favicons?domain={{ item }}&sz=48" alt="{{ item }} Favicon"/> <span>{{ item }}</span>
</ng-template>
